import { Tooltip } from '@/ui'
import { ShieldCheckIcon } from 'lucide-react'

export function JobillanBadge() {
	return (
		<Tooltip content="Only Jobillans can access this feature">
			<ShieldCheckIcon className="size-3.5" />
		</Tooltip>
	)
}
